import { Routes } from '@angular/router';
import { sessionGuard } from 'app/guards/session.guard';

export const usersAdminRoutes: Routes = [
  {
    canActivate: [sessionGuard],
    data: { key: 'users-admin' },
    loadComponent: () => import('./users-admin/users-admin.page').then((m) => m.UsersAdminPage),
    path: '',
  },
];
